
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/post/[url_path]",
      function () {
        return require("private-next-pages/post/[url_path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/post/[url_path]"])
      });
    }
  